class ProductRecipe extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('[data-recipe-key]');
    this.pinned = null;
    this.onDocumentClick = () => {
      this.pinned = null;
      this.highlight(null);
    };
    this.items.forEach((el) => {
      const key = el.dataset.recipeKey;
      el.addEventListener('mouseenter', () => {
        if (this.pinned === null) this.highlight(key);
      });
      el.addEventListener('mouseleave', () => {
        if (this.pinned === null) this.highlight(null);
      });
      el.addEventListener('click', (event) => {
        event.stopPropagation();
        this.pinned = this.pinned === key ? null : key;
        this.highlight(this.pinned);
      });
    });
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  highlight(key) {
    this.items.forEach((el) => {
      const on = key !== null && el.dataset.recipeKey === key;
      el.classList.toggle('is-on', on);
      el.classList.toggle('is-dim', key !== null && !on);
    });
  }
}

if (!customElements.get('product-recipe')) {
  customElements.define('product-recipe', ProductRecipe);
}
